import $ from 'jquery';
import Mmenu from 'mmenu-js'
import './scss/style.scss';
import gsap from 'gsap'
import customSelect from 'jquery-custom-select';
import Vimeo from '@vimeo/player';
import slick from 'slick-carousel';
import { debounce }  from 'throttle-debounce';

window.$ = $;
window.Mmenu = Mmenu;
window.gsap = gsap;
window.customSelect = customSelect;
window.Vimeo = Vimeo;
window.slick = slick;
window.$.debounce = debounce;

function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('./js/', true, /\.js$/));
requireAll(require.context('./theme/', true, /\.js$/)); 